import { shiftDetailKey } from 'queries/shifts/keys'

const assessmentsKey = 'assessments' as const

export const assessmentsKeys = {
  byShiftId: (shiftId: number) =>
    [...shiftDetailKey(shiftId), assessmentsKey] as const,
  byShiftAndWorkerId: (shiftId: number, workerId: number) =>
    [...shiftDetailKey(shiftId), assessmentsKey, workerId] as const,
}
